import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { withStyles } from '@material-ui/core/styles';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';

import Link from 'components/common/Link';

const styles = theme => ({
  root: {
    paddingTop: 5,
    paddingBottom: 5,
    marginBottom: 16,
    justifyContent: 'space-between',
    borderBottom: `1px solid ${theme.palette.primary.A100}`,
    [theme.breakpoints.down('sm')]: {
      marginBottom: 8,
    },
  },
});

const OrderInformationSectionTitle = ({
  title, className, onAddButtonClick, addButtonOwns, addButtonDisabled, classes,
}) => (
  <Toolbar
    className={classNames(className, classes.root)}
    disableGutters
  >
    <Typography color="secondary">
      {title}
    </Typography>
    {onAddButtonClick &&
      <Link
        color="primary"
        bold
        size="md"
        aria-label="More"
        aria-owns={addButtonOwns}
        aria-haspopup="true"
        onClick={onAddButtonClick}
        disabled={addButtonDisabled}
      >
        Add
      </Link>
    }
  </Toolbar>
);

OrderInformationSectionTitle.propTypes = {
  title: PropTypes.string.isRequired,
  className: PropTypes.string,
  onAddButtonClick: PropTypes.func,
  addButtonOwns: PropTypes.string,
  addButtonDisabled: PropTypes.bool,
  classes: PropTypes.shape({
    root: PropTypes.string.isRequired,
  }).isRequired,
};

OrderInformationSectionTitle.defaultProps = {
  className: '',
  onAddButtonClick: null,
  addButtonOwns: null,
  addButtonDisabled: false,
};

export default withStyles(styles)(OrderInformationSectionTitle);



// WEBPACK FOOTER //
// ./src/components/workflow/OrderInformation/OrderInformationSectionTitle.js